import { Page } from './PageObjClass'
import { provideDefaultPageLayoutComponent } from '../defaultPageLayoutComponent'

provideDefaultPageLayoutComponent(Page)
